import { Engine } from '../../core/Engine';
import { ScaleCommand } from '../Commands';
import { Scale } from '../../entities/Transform/Scale';
import { GraphicElement } from '../../entities/Drawable/GraphicElement';
import { Image } from '../../entities/Drawable/Image';

export class ScaleCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: ScaleCommand) {
        const obj: GraphicElement | null = this.engine.find(command.uuid);
        if (!obj || obj.isLocked) {
            return;
        }
        const oldScaleX = obj.scale.scaleX;
        const oldScaleY = obj.scale.scaleY;
        const scaleX = isNaN(command.scaleX) ? obj.scale.scaleX : command.scaleX;
        const scaleY = isNaN(command.scaleY) ? obj.scale.scaleY : command.scaleY;
        obj.transform.resize(new Scale(scaleX, scaleY));

        if (obj instanceof Image && obj.clipPath) {
            const clipPathscaleX = (obj.clipPath.scale.scaleX * obj.scale.scaleX) / oldScaleX;
            const clipPathscaleY = (obj.clipPath.scale.scaleY * obj.scale.scaleY) / oldScaleY;
            obj.clipPath?.transform.resize(new Scale(clipPathscaleX, clipPathscaleY));
        }
    }
}
